import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SpinnerService {

    private showSpinner = new BehaviorSubject<boolean>(false); 

    showSpinner$:  Observable<boolean> = this.showSpinner.asObservable();


    constructor( ) { }

    Spinner(showHide : string)
    {
        if (showHide.toUpperCase() == "HIDE") { this.showSpinner.next(false);}
        else if (showHide.toUpperCase() == "SHOW") { this.showSpinner.next(true);}
        else { this.showSpinner.next(false);}

    }
}